'use strict';

const LocaleUtils = {
    getCurrentLocale() {
        return navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || 'en-gb';
    }
};

module.exports = LocaleUtils;



/** WEBPACK FOOTER **
 ** ./src/utils/LocaleUtils.js
 **/